import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import _EXT_Integrante from "../../Componentes/Compuestos/Complejos/Clientes/EXT_Integrante"
import { PaginaExternaCliente } from "../../Componentes/Compuestos/Paginas/PaginaExternaCliente";
import { Button, NumberBox, SelectBox, TextBox } from "devextreme-react";
import { function_ABM_ART_Articulos_LeerPrecio, function_ABM_ART_Articulos_LeerPrecioDesdeWeb, function_ABM_ART_Articulos_ListarCompleto, function_ABM_ART_Articulos_VendiblesWEBCompleto } from "neftis7_apicaller/src/funciones/ABM/ART/ABM_ART_Articulos";
import { FormateoFechaPara_yyyyMMdd } from "neftis7_apicaller/src/funciones/Varios";
import LVButtonAccion from "../../Componentes/Basicos/LVButtonAccion";
import { function_VEN_Pedidos_Cabecera_Insertar, function_VEN_Pedidos_Generar_JSON } from "neftis7_apicaller/src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera";
import { function_ABM_EEX_Clientes_Leer } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_Clientes";
import { function_ABM_EEX_ClientesLocaciones_Listar } from "neftis7_apicaller/src/funciones/ABM/EEX/ABM_EEX_ClientesLocaciones";

export const _PCL_Pedidos_ModificacionCreacion = () => {
  const [loading, setLoading] = useState(true)
  const [carrito, setCarrito] = useState([]);
  const [articulos, setArticulos] = useState([]);
  const [filtroNombre, setFiltroNombre] = useState("");
  const [filtroTipo, setFiltroTipo] = useState("");
  const [filtroSubtipo, setFiltroSubtipo] = useState("");

  useEffect(() => {
    const ejecucion = async () => {
      try {
        setLoading(true)
        const resultArticulos = await function_ABM_ART_Articulos_VendiblesWEBCompleto(FormateoFechaPara_yyyyMMdd(new Date()))
        setArticulos(resultArticulos.data);

        const primerSubtipo = resultArticulos.data.find(p => !!p.SubtipoVentas)?.SubtipoVentas;
        setFiltroSubtipo(primerSubtipo || "");
      } catch (error) {
        alert(error)
      } finally {
        setLoading(false);
      }
    }

    ejecucion()
  }, []);

  const agregarAlCarrito = (producto, seleccion, cantidad, importeTotal, importeNeto, importeIVA, porcentajeIVA) => {
    if (cantidad <= 0) return;
    const itemExistente = carrito.find(
      x => x.CodigoArticulo === producto.CodigoArticulo &&
        x.Presentacion === seleccion.Presentacion &&
        x.Tamano === seleccion.Tamano &&
        x.Unidad === seleccion.Unidad
    );
    if (itemExistente) return;
    setCarrito([...carrito, {
      ...producto, ...seleccion, Cantidad: cantidad,
      ImporteTotal: Number(importeTotal), ImporteNeto: Number(importeNeto), ImporteIVA: Number(importeIVA),
      PorcentajeIVA: Number(porcentajeIVA)
    }]);
    // 🔁 Acá se podría hacer una llamada a la API para obtener el precio exacto
  };

  const borrarDelCarrito = (index) => {
    const nuevoCarrito = [...carrito];
    nuevoCarrito.splice(index, 1);
    setCarrito(nuevoCarrito);
  };

  const handleOnClick_CrearPedido = async () => {
    try {
      if (carrito.length === 0) return alert("El Pedido está vacío");

      setLoading(true)

      const Detalles =
        carrito.map(item => ({
          CodigoArticulo: item.CodigoArticulo,
          CodigoPresentacion: item.Presentacion,
          CodigoTamano: item.Tamano,
          CodigoUnidadMedida: item.Unidad,
          Cantidad: item.Cantidad,
          ImporteNeto: item.ImporteNeto,
          ImporteIVA: item.ImporteIVA,
          PorcentajeIVA: item.PorcentajeIVA,
          ImporteTotal: item.Precio,
          ImporteRecargos: 0,
          ImporteDescuentos: 0,

          ImporteNetoTotal: item.ImporteNeto * item.Cantidad,
          ImporteIVATotal: item.ImporteIVA * item.Cantidad,
          ImporteTotalTotal: item.Precio * item.Cantidad,
          ImporteRecargosTotal: 0,
          ImporteDescuentosTotal: 0,

          Observaciones: item.Descripcion,
          DescripcionArticulo: item.Descripcion,
          CodigoUbicacionIngreso: "DEF",
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
          CodigoPlanta: localStorage.getItem("CodigoPlanta"),
        }))

      const resultCliente = await function_ABM_EEX_Clientes_Leer(localStorage.getItem("IdCliente"))
      const IdDocVentaTipo = resultCliente.data.IdTipoDocVentaDefault

      const resultLocacionesCliente = await function_ABM_EEX_ClientesLocaciones_Listar(localStorage.getItem("IdCliente"))
      const CodigoLocacion = resultLocacionesCliente.data[0].CodigoLocacionCliente

      const Pedido = await function_VEN_Pedidos_Generar_JSON(0, 1, IdDocVentaTipo,
        FormateoFechaPara_yyyyMMdd(new Date()), localStorage.getItem("IdCliente"), null, null, null, null, "PA",
        1, 0, 0, "", "PORTAL DE CLIENTES", false, FormateoFechaPara_yyyyMMdd(new Date()), null, false, null, null,
        null, null, null, null, "DO", false, false, false, false, null, null, CodigoLocacion, null, null, null, null, null,
        Detalles, [], [])

      const resultPedido = await function_VEN_Pedidos_Cabecera_Insertar(Pedido)

      alert("✅ Pedido creado correctamente");
      setCarrito([]); // Limpiamos el carrito
    } catch (error) {
      console.error("Error al crear pedido:", error);
      alert("❌ No se pudo crear el pedido");
    } finally {
      setLoading(false)
    }
  };

  const tipos = [...new Set(articulos.map(p => p.TipoVentas))];
  const subtipos = [...new Set(articulos.map(p => p.SubtipoVentas))];

  const articulosFiltrados = articulos.filter(p =>
    p.Descripcion.toLowerCase().includes(filtroNombre.toLowerCase()) &&
    (filtroTipo ? p.Tipo === filtroTipo : true) &&
    (filtroSubtipo ? p.SubtipoVentas === filtroSubtipo : true)
  );

  const ArticuloCard = ({ producto, onAgregar }) => {
    const [presentacion, setPresentacion] = useState("");
    const [tamano, setTamano] = useState("");
    const [unidad, setUnidad] = useState("");
    const [cantidad, setCantidad] = useState(0);
    const [importeTotal, setImporteTotal] = useState(0);
    const [importeNeto, setImporteNeto] = useState(0);
    const [importeIVA, setImporteIVA] = useState(0);
    const [porcentajeIVA, setPorcentajeIVA] = useState(0);
    const [imagen, setImagen] = useState(null);

    const estaListo = presentacion && tamano && unidad;
    const precioListo = importeTotal > 0;

    useEffect(() => {
      if (producto.Presentaciones?.length === 1) {
        setPresentacion(producto.Presentaciones[0].CodigoPresentacion);
      }
      if (producto.Tamanos?.length === 1) {
        setTamano(producto.Tamanos[0].CodigoTamano);
      }
      if (producto.UnidadesMedida?.length === 1) {
        setUnidad(producto.UnidadesMedida[0].CodigoUnidadMedida);
      }

      let mimeType = "image/jpeg"; // Valor por defecto

      // Detectar el formato a partir del encabezado de la cadena Base64
      if (producto.Imagen.startsWith("/9j/")) mimeType = "image/jpeg";
      else if (producto.Imagen.startsWith("iVBOR")) mimeType = "image/png";
      else if (producto.Imagen.startsWith("R0lGOD")) mimeType = "image/gif";

      const imagenUrl = `data:${mimeType};base64,${producto.Imagen}`;
      setImagen(imagenUrl);
    }, [producto]);

    useEffect(() => {
      const ejecucion = async () => {
        if (presentacion && tamano && unidad && presentacion != "" && tamano != "" && unidad != "") {
          try {
            const responsePrecio = await function_ABM_ART_Articulos_LeerPrecioDesdeWeb(producto.CodigoArticulo, presentacion, tamano, unidad);

            setImporteTotal(responsePrecio.data.ImporteTotal)
            setImporteNeto(responsePrecio.data.ImporteNeto)
            setImporteIVA(responsePrecio.data.ImporteIVA)
            setPorcentajeIVA(responsePrecio.data.PorcentajeIVA)
          } catch (error) {
            console.error("Error al obtener el precio:", error);
          }
        }
      }

      ejecucion()
    }, [presentacion, tamano, unidad]);

    return (
      <div style={{
        border: "1px solid #e0e0e0",
        borderRadius: 12,
        padding: 15,
        width: 220,
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        backgroundColor: "#fff"
      }}>
        <img
          src={imagen}
          alt={producto.Descripcion}
          style={{
            width: "100%",
            height: 140,
            objectFit: "cover",
            borderRadius: 8,
            marginBottom: 10
          }}
        />
        <h4 style={{ fontSize: 16, textAlign: "center", margin: "10px 0" }}>
          {producto.Descripcion}
        </h4>

        {/* Selectores */}
        <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: 8 }}>
          {producto.UnidadesMedida.length > 1 ? (
            <SelectBox
              dataSource={producto.UnidadesMedida.map(p => p.CodigoUnidadMedida)}
              placeholder="Unidad"
              value={unidad}
              onValueChanged={e => setUnidad(e.value)}
              elementAttr={{ style: "font-size: 10px;" }}
            />
          ) : (
            <div style={{ fontSize: 10, textAlign: "center" }}>
              {producto.UnidadesMedida[0].Descripcion.toUpperCase()}
            </div>
          )}

          {producto.Presentaciones.length > 1 ? (
            <SelectBox
              dataSource={producto.Presentaciones.map(p => p.CodigoPresentacion)}
              placeholder="Presentación"
              value={presentacion}
              onValueChanged={e => setPresentacion(e.value)}
              elementAttr={{ style: "font-size: 10px;" }}
            />
          ) : (
            <div style={{ fontSize: 10, textAlign: "center" }}>
              {producto.Presentaciones[0].Descripcion.toUpperCase()}
            </div>
          )}

          {producto.Tamanos.length > 1 ? (
            <SelectBox
              dataSource={producto.Tamanos.map(p => p.CodigoTamano)}
              placeholder="Tamaño"
              value={tamano}
              onValueChanged={e => setTamano(e.value)}
              elementAttr={{ style: "font-size: 10px;" }}
            />
          ) : (
            <div style={{ fontSize: 10, textAlign: "center" }}>
              {producto.Tamanos[0].Descripcion.toUpperCase()}
            </div>
          )}
        </div>

        {/* Precio */}
        <div style={{ fontSize: 20, fontWeight: "bold", color: "#28a745", margin: "10px 0" }}>
          {"$ " + (Number(importeTotal) || 0).toFixed(0)}
        </div>

        {/* Cantidad + Botón */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, width: "100%" }}>
          <NumberBox
            value={cantidad}
            min={0}
            showSpinButtons
            onValueChanged={(e) => setCantidad(e.value)}
            width="100%"
          />
          {precioListo ? (
            <Button
              text="Agregar"
              stylingMode="contained"
              type="default"
              disabled={!estaListo || cantidad <= 0 || !precioListo}
              onClick={() => onAgregar(producto, { Presentacion: presentacion, Tamano: tamano, Unidad: unidad }, cantidad,
                (Number(importeTotal) || 0).toFixed(0), Number(importeNeto) || 0, Number(importeIVA) || 0, Number(porcentajeIVA) || 0)}
            />
          ) : (
            <div style={{ width: "100%", textAlign: "center", fontSize: 12, color: "#888" }}>Cargando precio...</div>
          )}
        </div>
      </div>
    );
  };

  return (
    <PaginaExternaCliente
      CodigoCompania={localStorage.getItem("CodigoCompania")}
      CodigoEmpresa={localStorage.getItem("CodigoEmpresa")}
      CodigoPlanta={localStorage.getItem("CodigoPlanta")} >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div style={{ padding: 20, height: "100vh", overflow: "auto" }}>
        <h2 style={{ marginBottom: 20 }}>🛒 CREACIÓN DE PEDIDOS</h2>

        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <TextBox value={filtroNombre} placeholder="Buscar artículo..." onValueChanged={e => setFiltroNombre(e.value)} />
          <SelectBox dataSource={tipos} placeholder="Tipo" value={filtroTipo} onValueChanged={e => setFiltroTipo(e.value)} />
          <SelectBox dataSource={subtipos} placeholder="Subtipo" value={filtroSubtipo} onValueChanged={e => setFiltroSubtipo(e.value)} />
          <Button text="Limpiar" onClick={() => { setFiltroNombre(""); setFiltroTipo(""); setFiltroSubtipo(""); }} />
        </div>

        <div style={{ display: "flex", gap: 10 }}>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 20, height: "80vh", overflow: "auto" }}>
            {articulosFiltrados.map((prod) => (
              <ArticuloCard key={prod.CodigoArticulo} producto={prod} onAgregar={agregarAlCarrito} />
            ))}
          </div>

          {carrito.length > 0 && (
            <div style={{
              flex: 1,
              minWidth: 600,
              maxWidth: 600,
              marginLeft: 15,
              position: "sticky",
              top: 20,
              alignSelf: "flex-start",
              height: "fit-content"
            }} >
              <h3>🧾 Tu pedido</h3>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={{ width: "40%", borderBottom: "1px solid #ccc" }}>Artículo</th>
                    <th style={{ width: "15%", borderBottom: "1px solid #ccc", textAlign: "right" }}>Cantidad</th>
                    <th style={{ width: "15%", borderBottom: "1px solid #ccc", textAlign: "right" }}>Precio</th>
                    <th style={{ width: "15%", borderBottom: "1px solid #ccc", textAlign: "right" }}>Total</th>
                    <th style={{ width: "15%", borderBottom: "1px solid #ccc" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {carrito.map((item, index) => (
                    <tr key={index}>
                      <td>{item.Descripcion} - {item.Presentacion} - {item.Tamano} - {item.Unidad}</td>
                      <td style={{ textAlign: "right" }}>{item.Cantidad}</td>
                      <td style={{ textAlign: "right" }}>${item.Precio}</td>
                      <td style={{ textAlign: "right" }}>${(item.Cantidad * item.Precio).toFixed(0)}</td>
                      <td><Button text="❌" stylingMode="text" onClick={() => borrarDelCarrito(index)} /></td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div style={{ height: "40px" }} ></div>

              <div style={{ display: "flex", justifyContent: "center", marginTop: 20 }}>

                <Button
                  text="CREAR PEDIDO"
                  type="success"
                  stylingMode="contained"
                  width="100%"
                  onClick={handleOnClick_CrearPedido}
                  disabled={loading}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </PaginaExternaCliente >
  );
};
